<div class="docs-component-viewer">
    <div class="docs-component-viewer-content">
        <router-outlet></router-outlet>
    </div>
</div>


